<template>
 <div class="Head">
    <div class="oahead">
        <div class="logo-tit">
            <img class="logo" src="../assets/logo.svg" @click="gohome" alt="">
            <h1 class="page-title">{{title}}</h1>
        </div>
        <el-button type="primary" v-if="showBack==true" class="goback" @click="returnPage">返回上一页</el-button>
    </div>
 </div>
</template>
<script>
import vm from '@/utils/event.js'
export default {
    name:'Head',
    data(){
        return{
            title:'优宁维协同办公',//爱必信备货库存
            showBack:true
        }
    },
    mounted(){
        this.getTilte()
    },
    methods:{
        returnPage(){
            if (window.history.length <= 1) {
                window.location.href = "http://oa.univ-bio.com"
                return false;
            } else {
                this.$router.go(-1);
            }
        },
        getTilte(){
            vm.$on("sendTit",(data)=>{ this.title = data });
            vm.$on("showBack",(data)=>{ this.showBack = data });
        },
        gohome(){
            window.location.href = process.env.NODE_ENV == 'production' ? 'http://oa.univ-bio.com' : 'http://oatest.univ-bio.com'
        }
    },
}
</script>
<style lang='scss' scoped>
.Head{
    margin-top: 30px;
}
.oahead{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding:20px 0;
    border-bottom: 1px solid #e60012;
 .logo-tit{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 48px;
    line-height: 48px;
    .logo{
    width: auto;
    height: 100%;
    cursor: pointer;
    }
    .page-title{
        padding-left: 24px;
        margin-left: 24px;
        border-left: 1px solid #DEDEDE;
        color:#555555;
        font-size: 18px;
        white-space: nowrap;
        font-weight: 500;
        height: 100%;
    }
 }

}
/deep/.el-button{
   padding: 6px 14px;
 }
</style>


// WEBPACK FOOTER //
// src/components/Head.vue